// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useAuthContext } from '@tls/auth';
import { Colors } from '@tls/treact-ui';
import { AnimationCss } from 'components/treactui-template/atoms/animation/AnimatePulse';
import { loadArrayIntoImageElement } from 'components/treactui-template/meta/loadImageIntoElement';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

interface Props {
  previewData?: Uint8Array<any>;
}

export default function PreviewImage({ previewData }: Readonly<Props>) {
  const imageElement = useRef<HTMLImageElement>(null);
  const { appBaseUrl } = useAuthContext();
  useEffect(() => {
    if (previewData) {
      loadArrayIntoImageElement([previewData], 'image/png', imageElement);
    }
  }, [previewData]);

  return <Image src={`${appBaseUrl}/images/image-placeholder.png`} ref={imageElement} />;
}
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: rgba(${Colors.trgrey2.rgb}, 0.4);
  ${AnimationCss}
`;
